"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordingClientV4 = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class RecordingClientV4 extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.baseUrl = '/v4/projects/';
    }
    getSessions(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/sessions`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getSessionsCount(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/sessions/count`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getPagesForSession(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber } = request, body = tslib_1.__rest(request, ["projectId", "visitorId", "sessionNumber"]);
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/${visitorId}/sessions/${sessionNumber}/pages`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getRecordingEvents(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber, pageNumber } = request;
            let url = `${this.baseUrl}${projectId}/session-replay/visitors/${visitorId}/sessions/${sessionNumber}/pages/${pageNumber}/recording-events`;
            if (request.queryNonce) {
                url += `?nonce=${request.queryNonce}`;
            }
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getMetadata(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber, pageNumber } = request, query = tslib_1.__rest(request, ["projectId", "visitorId", "sessionNumber", "pageNumber"]);
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/${visitorId}/sessions/${sessionNumber}/pages/${pageNumber}/metadata?${this.getQueryString(query)}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getVariables(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber, pageNumber, viewDateTime } = request;
            const queryString = this.getQueryString({ viewDateTime });
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/${visitorId}/sessions/${sessionNumber}/pages/${pageNumber}/variables?${queryString}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getSessionVars(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber, viewDateTime } = request;
            const queryString = this.getQueryString({ viewDateTime });
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/${visitorId}/sessions/${sessionNumber}/session-vars?${queryString}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getEncryptedNonce(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${projectId}/session-replay/encrypted-nonce`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getEncryptedRecordingEvents(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber, pageNumber, queryNonce } = request;
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/${visitorId}/sessions/${sessionNumber}/pages/${pageNumber}/recording-events-with-encrypted?nonce=${queryNonce}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getRecordingEventsWithUserIdentifier(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber, pageNumber, queryNonce } = request;
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/${visitorId}/sessions/${sessionNumber}/pages/${pageNumber}/events-with-encrypted-identifiers?nonce=${queryNonce}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getApiErrorsDetailsEncrypted(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber, pageNumber, eventId, queryNonce } = request;
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/${visitorId}/sessions/${sessionNumber}/pages/${pageNumber}/api-errors-details-encrypted?nonce=${queryNonce}&eventId=${eventId}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getCommentsThread(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber, pageNumber } = request;
            const url = `${this.baseUrl}${projectId}/session-replay/sessions/${visitorId}/${sessionNumber}/${pageNumber}/comments`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    createComment(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber, pageNumber } = request, body = tslib_1.__rest(request, ["projectId", "visitorId", "sessionNumber", "pageNumber"]);
            const url = `${this.baseUrl}${projectId}/session-replay/sessions/${visitorId}/${sessionNumber}/${pageNumber}/comments`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    updateComment(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber, pageNumber, id } = request, body = tslib_1.__rest(request, ["projectId", "visitorId", "sessionNumber", "pageNumber", "id"]);
            const url = `${this.baseUrl}${projectId}/session-replay/sessions/${visitorId}/${sessionNumber}/${pageNumber}/comments/${id}`;
            const response = yield this.httpPut(url, body);
            return response.payload;
        });
    }
    deleteComment(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber, pageNumber, id } = request;
            const url = `${this.baseUrl}${projectId}/session-replay/sessions/${visitorId}/${sessionNumber}/${pageNumber}/comments/${id}`;
            const response = yield this.httpDelete(url);
            return response.payload;
        });
    }
    getPageBySession(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber, pageNumber } = request;
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/${visitorId}/sessions/${sessionNumber}/pages/${pageNumber}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getPages(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/pages`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getPagesCount(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/pages/count`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getVisitors(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/visitors`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getVisitorsCount(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/count`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getTriggeredEventsForVisitors(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/events`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getTriggeredEventsForSessions(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/sessions/events`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getTriggeredEventsForPages(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/pages/events`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getPlayingToken(projectId, visitorId, sessionNumber, pageNumber) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${projectId}/session-replay/playingToken?${this.getQueryString({
                visitorId,
                sessionNumber,
                pageNumber,
            })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getFreshRecordingsFromVertica(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/fresh-recordings`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getClicktalePlayingToken(projectId, visitorId, sessionNumber, pageNumber, appUserId, appUserType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${projectId}/session-replay/playingToken?${this.getQueryString({
                visitorId,
                sessionNumber,
                pageNumber,
                appUserId,
                appUserType,
                type: 'clicktale',
            })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getClicktaleXStudioToken(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${projectId}/session-replay/xstudioToken`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
}
exports.RecordingClientV4 = RecordingClientV4;
//# sourceMappingURL=recording.client.v4.js.map